import { CxEvent } from '@spartacus/core';

export class GtmGgCartUpdateEntrySuccessEvent extends CxEvent {
  event?: any;
  productId?: string;
  ecommerce?: {
    currencyCode?: string;
    remove?: {
      products?: {
        name?: string;
        id?: string;
        price?: string | number;
        quantity?: string | number;
      }[];
    };
  };
}
